export { initialFrame } from './common';
const PARAMS_MAP = {
  soft: {
    scale: 1.2,
    ease: 'cubicInOut'
  },
  medium: {
    scale: 1.6,
    ease: 'quintInOut'
  },
  hard: {
    scale: 2,
    ease: 'backOut'
  }
};
export function web(options) {
  const [fadeIn, {
    custom,
    ...dropIn
  }] = style(options);
  return [{
    ...fadeIn,
    keyframes: [{
      opacity: 0
    }, {
      opacity: 'var(--comp-opacity, 1)'
    }]
  }, {
    ...dropIn,
    keyframes: [{
      scale: custom['--motion-scale']
    }, {
      scale: '1'
    }]
  }];
}
export function style(options) {
  const {
    power,
    initialScale = PARAMS_MAP.medium.scale
  } = options.namedEffect;
  const scale = power && PARAMS_MAP[power].scale || initialScale;
  const easing = power && PARAMS_MAP[power].ease || options.easing || 'quintInOut';
  return [{
    ...options,
    name: 'fadeIn',
    easing: 'quadOut',
    duration: options.duration * 0.8,
    custom: {}
  }, {
    ...options,
    name: 'dropIn',
    easing,
    custom: {
      '--motion-scale': `${scale}`
    }
  }];
}
//# sourceMappingURL=DropIn.js.map